var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isConsultantOrHolding(_vm.loggedUserData) ? _c("commissionListComponent", {
    attrs: {
      role: _vm.role,
      target: "consultant",
      loggedUserData: _vm.loggedUserData
    }
  }) : _c("Error", {
    attrs: {
      error: {}
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };